import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import "./App.css";
import StarryBackground from "./components/StarryBackground";
import TestingPage from "./pages/TestingPage";
import TestingPageTwo from "./pages/TestingPageTwo";
import TestingPageThree from "./pages/TestingPageThree";
import TestingPageFour from "./pages/TestingPageFour";
import TestingPageFive from "./pages/TestingPageFive";
import ProjectsSpacePage from "./pages/ProjectsSpacePage";
import ProjectsSpaceChapterPage from "./pages/ProjectsSpaceChapterPage";
import AboutPage from "./pages/AboutPage";
import LabPage from "./pages/LabPage";
import SolarLabPage from "./pages/SolarLabPage";
import ProjectPage from "./pages/ProjectPage";

function hasReturnState(state) {
  return Boolean(state?.returnFromProject || state?.returnFromAbout);
}

function ProjectsSpaceRedirect() {
  const location = useLocation();
  return <Navigate to="/projects" replace state={location.state} />;
}

function ProjectsSpacePlanetRedirect() {
  const { planetId } = useParams();
  const location = useLocation();
  return (
    <Navigate
      to={`/projects/${planetId || ""}`}
      replace
      state={location.state}
    />
  );
}

function AppRoutes() {
  const location = useLocation();
  const navigate = useNavigate();
  const [bootComplete, setBootComplete] = useState(false);

  useEffect(() => {
    if (bootComplete) return;
    if (hasReturnState(location.state)) {
      navigate(location.pathname, { replace: true, state: null });
    }
    setBootComplete(true);
  }, [bootComplete, location.pathname, location.state, navigate]);

  return (
    <Routes>
      <Route path="/" element={<TestingPage />} />
      <Route path="/home" element={<TestingPage />} />
      <Route path="/projects" element={<ProjectsSpacePage />} />
      <Route
        path="/projects/:planetId"
        element={<ProjectsSpaceChapterPage />}
      />
      <Route path="/projects-space" element={<ProjectsSpaceRedirect />} />
      <Route
        path="/projects-space/:planetId"
        element={<ProjectsSpacePlanetRedirect />}
      />
      <Route path="/testing" element={<TestingPage />} />
      <Route path="/testing-2" element={<TestingPageTwo />} />
      <Route path="/testing-3" element={<TestingPageThree />} />
      <Route path="/testing-4/*" element={<TestingPageFour />} />
      <Route path="/testing-5" element={<TestingPageFive />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/about/layer" element={<AboutPage />} />
      <Route path="/lab" element={<LabPage />} />
      <Route path="/solar-lab" element={<SolarLabPage />} />
      <Route path="/work/:id" element={<ProjectPage />} />
    </Routes>
  );
}

function App() {
  return (
    <Router basename={import.meta.env.BASE_URL}>
      <BackgroundLayer />
      <div className="app-ui-layer">
        <AppRoutes />
      </div>
    </Router>
  );
}

export default App;

function BackgroundLayer() {
  const location = useLocation();
  if (location.pathname === "/") return null;
  if (location.pathname === "/testing") return null;
  if (location.pathname.startsWith("/projects")) return null;
  if (location.pathname.startsWith("/projects-space")) return null;
  if (location.pathname === "/testing-2") return null;
  if (location.pathname === "/testing-3") return null;
  if (location.pathname.startsWith("/testing-4")) return null;
  if (location.pathname === "/testing-5") return null;
  if (location.pathname === "/lab") return null;
  if (location.pathname === "/solar-lab") return null;
  if (location.pathname.startsWith("/work")) return null;
  return <StarryBackground />;
}
